import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Store the current full URL (pathname + search params) before redirecting to auth
    const currentUrl = `${location.pathname}${location.search}`;
    sessionStorage.setItem('redirectAfterLogin', currentUrl);
    
    return <Navigate to="/auth" replace />;
  }

  // User is logged in, all subscription logic is now handled at cabinet level in DashboardLayout
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute; 